import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import {
    StoreModule as NGRXstoreModule,
    ActionReducerMap,
    MetaReducer,
} from '@ngrx/store';

import { reducers } from './config-reducers';
import { metaReducers, effectMiddleware } from './config-middleware';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        NGRXstoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictActionImmutability: false, //ทำให้ส่ง object ที่มีความ Complex มาก ๆ ผ่าน actoin ได้
            },
        }),
        EffectsModule.forRoot(effectMiddleware),
    ],
    exports: [NGRXstoreModule],
})
export class StoreModule {}
